export default "__VITE_ASSET__3ebc8190__"